import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useEffect } from "react";
import {
  LayoutDashboard, Package, Folder, ShoppingCart, Users, MessageSquare, Image as ImageIcon, FileText, Ticket, LogOut, Settings,
} from "lucide-react";

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors ${
    isActive ? "bg-[#0077B6] text-white" : "text-slate-700 hover:bg-slate-100"
  }`;

export default function AdminLayout() {
  const { user, logout, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) navigate("/giris");
  }, [user, loading, navigate]);

  if (loading || !user) return <div className="p-10">Yükleniyor...</div>;

  return (
    <div data-testid="admin-layout" className="min-h-screen bg-[#F4F7F9] flex">
      <aside className="w-64 bg-white border-r border-slate-200 p-4 hidden lg:flex flex-col">
        <Link to="/" className="block px-2 mb-7">
          <img src="/logo.png" alt="Midye Merkezi" className="h-20 w-auto object-contain mb-1" />
          <div className="font-display font-extrabold text-xs text-slate-500 uppercase tracking-widest">Admin Panel</div>
        </Link>
        <nav className="space-y-1 flex-1">
          <NavLink end to="/admin" className={linkCls}><LayoutDashboard size={16}/> Dashboard</NavLink>
          <NavLink to="/admin/urunler" className={linkCls}><Package size={16}/> Ürünler</NavLink>
          <NavLink to="/admin/kategoriler" className={linkCls}><Folder size={16}/> Kategoriler</NavLink>
          <NavLink to="/admin/siparisler" className={linkCls}><ShoppingCart size={16}/> Siparişler</NavLink>
          <NavLink to="/admin/musteriler" className={linkCls}><Users size={16}/> Müşteriler</NavLink>
          <NavLink to="/admin/yorumlar" className={linkCls}><MessageSquare size={16}/> Yorumlar</NavLink>
          <NavLink to="/admin/bannerlar" className={linkCls}><ImageIcon size={16}/> Bannerlar</NavLink>
          <NavLink to="/admin/blog" className={linkCls}><FileText size={16}/> Blog</NavLink>
          <NavLink to="/admin/kuponlar" className={linkCls}><Ticket size={16}/> Kuponlar</NavLink>
          <NavLink to="/admin/ayarlar" className={linkCls}><Settings size={16}/> Site Ayarları</NavLink>
        </nav>
        <button onClick={async () => { await logout(); navigate("/"); }} className="flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold text-rose-600 hover:bg-rose-50">
          <LogOut size={16}/> Çıkış
        </button>
      </aside>
      <main className="flex-1 overflow-x-auto"><div className="p-6 md:p-10"><Outlet /></div></main>
    </div>
  );
}
